import { render, staticRenderFns } from "./ModalUwr.vue?vue&type=template&id=5ee48f68&scoped=true&"
import script from "./ModalUwr.vue?vue&type=script&lang=js&"
export * from "./ModalUwr.vue?vue&type=script&lang=js&"
import style0 from "./ModalUwr.vue?vue&type=style&index=0&id=5ee48f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee48f68",
  null
  
)

export default component.exports